import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Rapports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number1: Math.floor(Math.random() * 100) + 1,
      number2: Math.floor(Math.random() * 1000) + 1,
      answer: "",
      min: 2,
      maxNumber1: 100,
      maxNumber2: 500,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var good = Math.trunc((this.state.number1 / this.state.number2) * 100);
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.number1 +
          " de " +
          this.state.number2 +
          " = " +
          good+
          "%",
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.number1 +
          " de " +
          this.state.number2 +
          " = " +
          good +
          "%",
      });
    }
    var n1 =
      Math.floor(
        Math.random() * (Number(this.state.maxNumber1) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var n2 =
      Math.floor(
        Math.random() * (Number(this.state.maxNumber2) - n1 + 1)
      ) + Number(this.state.min);
    this.setState({ number1: n1, number2: n2, answer: ""});
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Rapports</h2>
          </div>
        </div>

        <div className="container">
          <p>Réalisez une troncature à l’unité</p>
          <p>Exemple : 55,55% = 55</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerOperation}
          >
            <p
              className={this.state.messageColor}
              style={{ marginTop: 40, marginBottom: 20 }}
            >
              {this.state.message}
            </p>
            <div className="row">
              <label className="label-exos">
                {this.state.number1} de {this.state.number2} = ?%
              </label>
            </div>
            <input
              className="input-square"
              type="number"
              name="answer"
              value={this.state.answer} 
              onChange={this.myChangeHandler}
            />
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Rapports;
